<div class="accordion">
  <button
    class="accordion-header"
    (click)="toggle()"
    type="button"
  >
    <span class="accordion-title">{{ title() }}</span>
    <i
      class="fa accordion-icon"
      [class.fa-chevron-down]="isOpen()"
      [class.fa-chevron-right]="!isOpen()"
    ></i>
  </button>

  <div class="accordion-content" [class.open]="isOpen()">
    <div class="accordion-body">
      <ng-content />
    </div>
  </div>
</div>
